var _path, _path2, _path3, _path4, _path5, _path6, _text;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTvocs = function SvgTvocs(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba5a438d-a915-439d-9304-e3275bb92ca2",
    "data-name": "Layer 3",
    viewBox: "0 0 121.92 111.81",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M84.84,90.38A22.11,22.11,0,1,1,107,68.28,22.13,22.13,0,0,1,84.84,90.38Zm0-41.69a19.59,19.59,0,1,0,19.58,19.59A19.61,19.61,0,0,0,84.84,48.69Z",
    transform: "translate(-26.38 4.41)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M125.37,60.4a9,9,0,1,1,9-9A9,9,0,0,1,125.37,60.4Zm0-15.42a6.45,6.45,0,1,0,6.44,6.45A6.45,6.45,0,0,0,125.37,45Z",
    transform: "translate(-26.38 4.41)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M117.9,89.9a9,9,0,1,1,9-9A9,9,0,0,1,117.9,89.9Zm0-15.42a6.45,6.45,0,1,0,6.45,6.44A6.45,6.45,0,0,0,117.9,74.48Z",
    transform: "translate(-26.38 4.41)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M69.38,107.39a9,9,0,1,1,9-9A9,9,0,0,1,69.38,107.39Zm0-15.41a6.45,6.45,0,1,0,6.44,6.44A6.45,6.45,0,0,0,69.38,92Z",
    transform: "translate(-26.38 4.41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M56.61,50.65a9,9,0,1,1,9-9A9,9,0,0,1,56.61,50.65Zm0-15.41a6.45,6.45,0,1,0,6.45,6.44A6.45,6.45,0,0,0,56.61,35.24Z",
    transform: "translate(-26.38 4.41)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f5ee6834-d25f-40a5-b42e-715bc31c2071",
    d: "M43.41,79.75a9,9,0,1,1,9-9A9,9,0,0,1,43.41,79.75Zm0-15.42a6.45,6.45,0,1,0,6.45,6.45A6.45,6.45,0,0,0,43.41,64.33Z",
    transform: "translate(-26.38 4.41)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "ab39775a-e51c-4666-849e-6454661c9435",
    transform: "translate(9.53 30.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "e26cbcec-4363-44a8-86e3-7549170b41f9"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.33,
    y: 0
  }, "VOCS"))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTvocs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tvocs.58478ef4.svg";
export { ForwardRef as ReactComponent };